import Vue from 'vue'
import VueRouter from 'vue-router'
import store from "../store"

const AdviserDashboardContainer = () => import('@/components/AdviserDashboardContainer')
const Callback = () => import('@/components/Callback')
const Login = () => import('@/views/Login')
const ServiceCenter = () => import('@/views/ServiceCenter')
const Forms =() => import('@/views/Forms')
const AdviserPanel = () => import('@/views/AdviserPanel')
const BOPanel = () => import('@/views/BOPanel')
const FundPanel = () => import('@/views/FundPanel')
const FundDashboard =() => import('@/views/fundpanel/Dashboard')
const FundNavInvestments =() => import('@/views/fundpanel/navpages/FundNavInvestments')
const FundNavDocuments =() => import('@/views/fundpanel/navpages/FundNavDocuments')
const FundNavContributions =() => import('@/views/fundpanel/navpages/FundNavContributions')
const FundNavPensions =() => import('@/views/fundpanel/navpages/FundNavPensions')
const FundNavReports =() => import('@/views/fundpanel/navpages/FundNavReports')
const MemberBasicDetails =() => import('@/views/fundpanel/navpages/MemberBasicDetails')
const MemberBenefitEstimates =() => import('@/views/fundpanel/navpages/MemberBenefitEstimates')
const Inbox =()=>import('@/views/fundpanel/funddashboard/Inbox.vue')
const Outbox =()=>import('@/views/fundpanel/funddashboard/Outbox.vue')
const AdviserDashboard =() => import('@/views/adviserpanel/Dashboard')
const FundStatusAdviser =()=>import('@/views/adviserpanel/navpages/FundStatusAdviser')
const Cash =()=>import('@/views/adviserpanel/navpages/Cash')
const Contributions =()=>import('@/views/adviserpanel/navpages/Contributions')
const Insurance =()=>import('@/views/adviserpanel/navpages/Insurance')
const MinPension =()=>import('@/views/adviserpanel/navpages/MinPension')
const Tax =()=>import('@/views/adviserpanel/navpages/Tax')
const BODashboard =()=>import('@/views/bopanel/Dashboard')
const Page404 = () => import('@/components/Page404')




Vue.use(VueRouter)

let router = new VueRouter({
  mode: 'hash', // https://router.vuejs.org/api/#mode
  // linkActiveClass: 'active',
  // scrollBehavior: () => ({ y: 0 }),
  routes: configRoutes(),
  scrollBehavior() {
    return { x: 0, y: 0 };
  }
})

function configRoutes () {
  return [
    {
      path: '/login',
      name: 'Login',
      component: Login,
    },
    {
      path: '/callback',
      name: 'Callback',
      component: Callback
    },
    {
      path: '/',
      name: 'Home',
      component: AdviserDashboardContainer,
      meta: { 
        requiresAuth: true
      },
      redirect: function(){ 
        if (store.getters.isLoggedIn) {
          let userdetail = JSON.parse(localStorage.getItem('userdetail'));
          if(userdetail['isBO']==true){
            return '/businessoverview'
          }else{
            // return '/adviserdashboard/'+userdetail['brand_list'][0]['brand_code']
            return '/adviserdashboard'
          }
        }else{
          return '/login'
        }
        
      },
      children: [
        {
          // path: 'adviserdashboard/:brand',
          path: 'adviserdashboard',
          name: 'Dashboard',
          component: AdviserPanel,
          children:[
            {
              path:'',
              name:'adviserdashboard',
              component: AdviserDashboard
            },
            {
              path:'fund_status_adviser',
              name:"fund_status_adviser",
              component: FundStatusAdviser
            },
            {
              path:'cash_at_bank',
              name:"cash_at_bank",
              component: Cash
            },
            {
              path:'contributions',
              name:"contributions",
              component: Contributions
            },
            {
              path:'insurance',
              name:"insurance",
              component: Insurance
            },
            {
              path:'min_pension',
              name:"min_pension",
              component: MinPension
            },
            {
              path:'tax',
              name:"tax",
              component: Tax
            },
          ]
        },
        {
          path:'businessoverview',
          name: 'BusinessOverview',
          component: BOPanel,
          children:[
            {
              path:'',
              name:'bodashboard',
              component: BODashboard
            },
          ]
        },
        {
          path:'servicecenter',
          name:'ServiceCenter',
          component: ServiceCenter,
        },
        {
          path:'forms',
          name:'forms',
          component: Forms,
        },
        {
          path:'funddashboard/:fund_code',
          name:"FundDashboard",
          component: FundPanel,
          children:[
            {
              path:'',
              name:'funddashboard',
              component: FundDashboard
            },
            {
              path:'investments',
              name:"fund_nav_investments",
              component: FundNavInvestments
            },
            {
              path:'contributions',
              name:"fund_nav_contributions",
              component: FundNavContributions
            },
            {
              path:'documents',
              name:"fund_nav_documents",
              component: FundNavDocuments
            },
            {
              path:'pensions',
              name:"fund_nav_pensions",
              component: FundNavPensions
            },
            {
              path:'reports',
              name:"fund_nav_reports",
              component: FundNavReports
            },
            {
              path:'memberbasic',
              name:"member_basic",
              component: MemberBasicDetails
            },
            {
              path:'memberbenefit',
              name:"member_benefit",
              component: MemberBenefitEstimates
            },
            {
              path:'inbox',
              name:"inbox",
              component: Inbox
            },
            {
              path:'outbox',
              name:"outbox",
              component: Outbox
            },
          ]
        },
        
      ]
    },
    {
      path: '/*',
      name: 'error-404',
      meta: { title: '404-Page Not Found' },
      component: Page404
    }
    
  ]

}



router.beforeEach((to, from, next) => {
  if(to.matched.some(record => record.meta.requiresAuth)) {
    if (store.getters.isLoggedIn) {
      next()
      
      return
    }
    next('/login/')
  } else {
    next()
  }
})

export default router